import { render, staticRenderFns } from "./preTestBody.vue?vue&type=template&id=1c852b0d&"
import script from "./preTestBody.vue?vue&type=script&lang=js&"
export * from "./preTestBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports